import type {FC} from 'react';
import {styled} from 'styled-components';
import {useLocation} from 'wouter';

import {UnthemedNavLink} from '@repo/shared-web/components/core/button';

interface NavBarProps {}

export const NavBar: FC = () => {
  const [location] = useLocation();
  return (
    <Wrapper>
      <StyledNavLink $active={location === '/nzbsu'} to="/nzbsu">
        NZB.su
      </StyledNavLink>
      <StyledNavLink $active={location === '/browse'} to="/browse">
        Movies
      </StyledNavLink>
      <StyledNavLink $active={location === '/debug/nzb-health'} to="/debug/nzb-health">
        NZB checks
      </StyledNavLink>
    </Wrapper>
  );
};

NavBar.displayName = 'NavBar';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 64px;
  flex-shrink: 0;
  background: #1f242f;
  box-shadow: 0px 4px 10px -10px black;
`;

const StyledNavLink = styled(UnthemedNavLink)<{$active: boolean}>`
  color: #ffffffcc;
  padding: 8px 16px;
  border-radius: 4px;
  ${p => p.$active && 'background: #ffffff11;'}
  &:hover {
    ${p => !p.$active && 'background: #ffffff05;'}
  }
`;
